export default __webpack_public_path__ + "static/media/accessing_the_dashboard_2.479974f1.png";